import { useIsMobile } from '../../utils/useIsMobile';

const ContactComponent: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? (
        <>
          <div className='title title-mobile content-wrapper'>YHTEYS</div>
          <div className='text-body text-body-mobile content-wrapper'>
            {'kirke(at)kirkeband.fi'}
          </div>
        </>
      ) : (
        <>
          <div className='title title-desktop content-wrapper'>YHTEYS</div>
          <div className='text-body text-body-desktop content-wrapper'>
            {'kirke(at)kirkeband.fi'}
          </div>
        </>
      )}
    </>
  );
};

export default ContactComponent;
